/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, simpleLocalAttribute } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData } from '@touchplan/common';
import { Organization } from './Organization';
import { Project } from './Project';

export interface IBaseOrganizationProjectFields {
	organizationId: string;
	projectId: string;
}

export interface IOrganizationProjectFields extends IBaseOrganizationProjectFields {
	organization: Organization;
	project: Project;
}

export class OrganizationProject extends SplitData<IOrganizationProjectFields, DefaultSplitDataRenderType> {
	protected attributeList = Object.assign(generateSimplestList(['organizationId', 'projectId']), {
		organization: simpleLocalAttribute,
		project: simpleLocalAttribute,
	});

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
